import _regeneratorRuntime from "G:/webgit/pc-chitengmall/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js";
import _asyncToGenerator from "G:/webgit/pc-chitengmall/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _classCallCheck from "G:/webgit/pc-chitengmall/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "G:/webgit/pc-chitengmall/node_modules/@babel/runtime/helpers/esm/createClass.js";
import _callSuper from "G:/webgit/pc-chitengmall/node_modules/@babel/runtime/helpers/esm/callSuper.js";
import _inherits from "G:/webgit/pc-chitengmall/node_modules/@babel/runtime/helpers/esm/inherits.js";
import "core-js/modules/es.array.push.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.number.constructor.js";
import { __decorate } from "tslib";
import { Component, Vue } from 'vue-property-decorator';
import Header from '@/common/header.vue';
import Footer from '@/common/footer.vue';
import CountDown from '@/components/countdown/index.vue';
import { aliPayPc, orderDetail, pageVisit as _pageVisit, getDataCard, getDataBanner, getDataReCommend, getDataProType } from '@/services/http';
import { secondToTime, readCookie, writeCookie } from '@/tools/tools';
var default_1 = /*#__PURE__*/function (_Vue) {
  function default_1() {
    var _this;
    _classCallCheck(this, default_1);
    _this = _callSuper(this, default_1, arguments);
    // 支付类型，1支付宝支付,2微信支付,
    _this.radio = readCookie('paytype') ? readCookie('paytype') : 1;
    _this.totalPrice = '';
    _this.paytime = 0; // 订单支付倒计时时间
    _this.surplus = 0;
    return _this;
  }
  _inherits(default_1, _Vue);
  return _createClass(default_1, [{
    key: "created",
    value: function created() {
      this.getPayTime();
    }
  }, {
    key: "destroyed",
    value: function destroyed() {}
  }, {
    key: "beforeRouteLeave",
    value: function beforeRouteLeave(to, from, next) {
      var _this2 = this;
      if (to.name === 'orderConfirm') {
        next(false);
        this.$msgbox({
          title: '确认要取消支付订单?',
          message: "\u60A8\u7684\u8BA2\u5355\u5728".concat(secondToTime(this.surplus), "\u5185\u672A\u652F\u4ED8\u5C06\u88AB\u53D6\u6D88\uFF0C\u8BF7\u5C3D\u5FEB\u5B8C\u6210\u652F\u4ED8\u3002"),
          showCancelButton: true,
          confirmButtonText: '确认离开',
          cancelButtonText: '继续支付',
          beforeClose: function () {
            var _beforeClose = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee(action, instance, done) {
              return _regeneratorRuntime().wrap(function _callee$(_context) {
                while (1) switch (_context.prev = _context.next) {
                  case 0:
                    if (action === 'confirm') {
                      _this2.$router.push({
                        path: '/order-list?id=0'
                      });
                      done();
                    } else {
                      _this2.gopay();
                      done();
                    }
                  case 1:
                  case "end":
                    return _context.stop();
                }
              }, _callee);
            }));
            function beforeClose(_x, _x2, _x3) {
              return _beforeClose.apply(this, arguments);
            }
            return beforeClose;
          }()
        });
      } else {
        next(true);
      }
    }
  }, {
    key: "selectPay",
    value: function selectPay(radio) {
      this.radio = radio;
    }
    // 访问页面数据埋点
  }, {
    key: "pageVisit",
    value: function pageVisit() {
      var anchor = readCookie('anchor');
      _pageVisit({
        pageType: 10,
        equip: anchor ? anchor.equip : 4,
        version: anchor ? anchor.version : '',
        src: anchor ? anchor.src ? anchor.src : 2 : 4,
        model: anchor ? anchor.model : '',
        equipVersion: anchor ? anchor.equipVersion : '',
        equipMeid: anchor ? anchor.equipMeid : '',
        companyId: 1
      });
    }
  }, {
    key: "gopay",
    value: function () {
      var _gopay = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
        var anchor, from, url, res, div;
        return _regeneratorRuntime().wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              anchor = readCookie('anchor');
              from = this.$route.query.from;
              if (from === 'card') {
                url = getDataCard;
              } else if (from === 'classify') {
                url = getDataProType;
              } else if (from === 'carousel') {
                url = getDataBanner;
              } else {
                url = getDataReCommend;
              }
              if (!(this.radio === 1)) {
                _context2.next = 21;
                break;
              }
              _context2.next = 6;
              return aliPayPc({
                orderNo: this.$route.query.id,
                equip: '',
                version: ''
              });
            case 6:
              res = _context2.sent;
              if (!(res.data.code === 100)) {
                _context2.next = 18;
                break;
              }
              if (!from) {
                _context2.next = 11;
                break;
              }
              _context2.next = 11;
              return url({
                src: anchor ? anchor.src ? anchor.src : 2 : 4,
                equip: anchor ? anchor.equip : 4,
                version: anchor ? anchor.version : '',
                model: anchor ? anchor.model : '',
                equipVersion: anchor ? anchor.equipVersion : '',
                equipMeid: anchor ? anchor.equipMeid : '',
                companyId: 1,
                // eslint-disable-next-line no-nested-ternary
                eventNo: from === 'card' ? '2.2.1.1.1.0.1' : from === 'classify' ? '2.3.1.1.1.1.1' : from === 'carousel' ? '2.4.1.1.1.0.1' : from === 'hotlist' ? '2.5.1.1.1.0.1' : ''
              });
            case 11:
              div = document.createElement('div');
              document.body.appendChild(div);
              div.innerHTML = res.data.data.form;
              document.forms[0].submit();
              writeCookie('paytype', this.radio);
              _context2.next = 19;
              break;
            case 18:
              this.$message.error(res.data.message);
            case 19:
              _context2.next = 26;
              break;
            case 21:
              if (!from) {
                _context2.next = 24;
                break;
              }
              _context2.next = 24;
              return url({
                src: anchor ? anchor.src ? anchor.src : 2 : 4,
                equip: anchor ? anchor.equip : 4,
                version: anchor ? anchor.version : '',
                model: anchor ? anchor.model : '',
                equipVersion: anchor ? anchor.equipVersion : '',
                equipMeid: anchor ? anchor.equipMeid : '',
                // eslint-disable-next-line no-nested-ternary
                eventNo: from === 'card' ? '2.2.1.1.1.0.2' : from === 'classify' ? '2.3.1.1.1.1.2' : from === 'carousel' ? '2.4.1.1.1.0.2' : from === 'hotlist' ? '2.5.1.1.1.0.2' : ''
              });
            case 24:
              writeCookie('paytype', this.radio);
              this.$router.push("/paymentwx?id=".concat(this.$route.query.id));
            case 26:
            case "end":
              return _context2.stop();
          }
        }, _callee2, this);
      }));
      function gopay() {
        return _gopay.apply(this, arguments);
      }
      return gopay;
    }() //  获取支付倒计时时间
  }, {
    key: "getPayTime",
    value: function () {
      var _getPayTime = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee3() {
        var anchor, res;
        return _regeneratorRuntime().wrap(function _callee3$(_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              anchor = readCookie('anchor');
              _context3.next = 3;
              return orderDetail({
                orderNo: this.$route.query.id,
                src: anchor ? anchor.src ? anchor.src : 2 : 4,
                equip: anchor ? anchor.equip : 4,
                version: anchor ? anchor.version : ''
              });
            case 3:
              res = _context3.sent;
              if (res.data.code === 100) {
                this.paytime = Date.now() + Number(res.data.data.surplus) * 1000;
                this.surplus = +res.data.data.surplus;
                this.totalPrice = res.data.data.totalAmount;
              }
            case 5:
            case "end":
              return _context3.stop();
          }
        }, _callee3, this);
      }));
      function getPayTime() {
        return _getPayTime.apply(this, arguments);
      }
      return getPayTime;
    }()
  }]);
}(Vue);
default_1 = __decorate([Component({
  components: {
    Header: Header,
    Footer: Footer,
    CountDown: CountDown
  }
})], default_1);
export default default_1;